import React from 'react';

const SITE_URL = 'https://euchretable.com';
const SHARE_TEXT = 'Check out Euchre Table - Play Buck Euchre online for free!';
const LOGO_URL = `${SITE_URL}/BuckEuchreLogoWhite.png`;

function ShareButton({ href, label, color, icon, isMobile }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={`Share on ${label}`}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        background: color, color: '#fff', border: 'none', borderRadius: 6,
        padding: isMobile ? '5px 10px' : '6px 12px',
        fontSize: isMobile ? 11 : 12, fontWeight: 600,
        textDecoration: 'none', cursor: 'pointer',
        transition: 'opacity 0.2s'
      }}
      onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
      onMouseLeave={e => e.currentTarget.style.opacity = '1'}
    >
      <span style={{ fontSize: isMobile ? 14 : 16 }}>{icon}</span>
      {!isMobile && label}
    </a>
  );
}

export default function Footer({ isMobile }) {
  const xUrl = `https://x.com/intent/tweet?text=${encodeURIComponent(SHARE_TEXT)}&url=${encodeURIComponent(SITE_URL)}`;
  const redditUrl = `https://www.reddit.com/submit?url=${encodeURIComponent(SITE_URL)}&title=${encodeURIComponent(SHARE_TEXT)}`;
  // Instagram doesn't have a direct share URL, so we link to our profile/page
  const instagramUrl = `https://www.instagram.com/`;

  return (
    <div style={{
      marginTop: isMobile ? 32 : 48,
      borderTop: '1px solid #30363d',
      paddingTop: isMobile ? 16 : 24,
      paddingBottom: isMobile ? 24 : 32,
      textAlign: 'center'
    }}>
      {/* Share buttons */}
      <div style={{ marginBottom: isMobile ? 12 : 16 }}>
        <div style={{
          fontSize: isMobile ? 11 : 12, color: '#8b949e',
          fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1,
          marginBottom: 8
        }}>
          Share Euchre Table
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: isMobile ? 6 : 8, flexWrap: 'wrap' }}>
          <ShareButton href={xUrl} label="X" color="#000" icon="&#120143;" isMobile={isMobile} />
          <ShareButton href={redditUrl} label="Reddit" color="#FF4500" icon="&#9673;" isMobile={isMobile} />
          <ShareButton
            href={instagramUrl}
            label="Instagram"
            color="linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)"
            icon="&#128247;"
            isMobile={isMobile}
          />
        </div>
      </div>

      {/* Contact */}
      <div style={{ fontSize: isMobile ? 11 : 12, color: '#8b949e' }}>
        <a
          href="mailto:info@euchretable.com"
          style={{ color: '#58a6ff', textDecoration: 'none', fontWeight: 500 }}
        >
          info@euchretable.com
        </a>
        <span style={{ margin: '0 8px', color: '#30363d' }}>|</span>
        <span style={{ color: '#6b7280' }}>&copy; {new Date().getFullYear()} Euchre Table</span>
      </div>
    </div>
  );
}
